module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Bold.woff
// module id = 683
// module chunks = 0